import { render, staticRenderFns } from "./subgroups.vue?vue&type=template&id=acb1cdd0&scoped=true&"
import script from "./subgroups.vue?vue&type=script&lang=js&"
export * from "./subgroups.vue?vue&type=script&lang=js&"
import style0 from "./subgroups.vue?vue&type=style&index=0&id=acb1cdd0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb1cdd0",
  null
  
)

export default component.exports